import React, { useEffect } from "react";
import { FormControlLabelSmall, DarkRadio } from "../../../Themes/StyledElements"
import { RadioGroup, Grid, Typography } from "@material-ui/core"
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked"
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked"
import { Control, Controller, FormState } from "react-hook-form"

// Fonction pour accéder aux erreurs imbriquées
const getNestedError = (errors: any, name: string) => {
    // Convertir le nom du champ en tableau de clés
    // Par exemple, "spot.productNature" devient ["spot", "productNature"]
    // "works.[0].workCode" devient ["works", "0", "workCode"]
    const keys = name.replace(/\.\[/g, '.').replace(/\]/g, '').split('.');

    // Parcourir l'objet d'erreurs en suivant le chemin des clés
    let current = errors;
    for (const key of keys) {
        if (!current || !current[key]) {
            return undefined;
        }
        current = current[key];
    }

    return current.message;
};

export const FormRadioField = ({
    label,
    name,
    control,
    disabled,
    formState,
    required,
    helperText,
    choices,
    onChange
}: { label: string, name: string, control: Control, disabled?: boolean, formState: FormState<any>, required?: boolean, helperText?: string, choices: { value: string, label: string }[], onChange?: (value: string) => void }) => {
    // Récupérer le message d'erreur pour ce champ
    const errorMessage = getNestedError(formState.errors, name);

    return (
        <Grid item container style={{ marginTop: '15px' }}>
            <Grid item xs={2}>
                {label} {required && <span style={{ color: 'red' }}>*</span>}
            </Grid>
            <Grid item xs={10}>
                <Controller
                    control={control}
                    name={name}
                    defaultValue={required && choices.length > 0 ? choices[0].value : ""}
                    render={(field) => {
                        const { value, onChange: onChangeField } = field

                        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                            // Capture la nouvelle valeur
                            const newValue = e.target.value;
                            // Mettre à jour le champ
                            onChangeField(e)
                            // Appeler le callback onChange avec la NOUVELLE valeur
                            if (onChange) {
                                // On utilise setTimeout pour s'assurer que le state est bien mis à jour
                                setTimeout(() => {
                                    onChange(newValue)
                                }, 0)
                            }
                        }

                        return (
                          <RadioGroup
                            style={{ flexDirection: 'row' }}
                            value={value || ''}
                            name={name}
                            onChange={handleChange}
                          >
                            {choices.map((choice) => (
                              <FormControlLabelSmall
                                key={choice.value}
                                value={choice.value}
                                control={
                                  <DarkRadio
                                    icon={<RadioButtonUncheckedIcon />}
                                    checkedIcon={<RadioButtonCheckedIcon />}
                                  />
                                }
                                label={choice.label}
                              />
                            ))}
                          </RadioGroup>
                        );
                    }}
                />
                {errorMessage && <Typography variant="caption" color="error">{errorMessage}</Typography>}
                {!errorMessage && helperText && <Typography variant="caption" color="textSecondary">{helperText}</Typography>}
            </Grid>
        </Grid>
    )
}